import styled from "styled-components";
import { ListItemProps } from ".";

export const ListItem = styled.div<ListItemProps>`
  height: fit-content !important;
  width: 100%;

  display: flex;
  flex-direction: column;

  margin-bottom: 20px;
  transition: transform ${({ theme }) => theme.animation.duration};
  transform: translateY(0);
  will-change: transform;

  @media ${({ theme }) => theme.devices.laptop} {
    &:hover {
      ${({ hover }) =>
        hover && "transform: translateY(-10px)"}; /* Move para cima */
    }
  }
`;
